import * as Yup from 'yup';
import { Navigate, useRoutes, useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useSearchParams, useRouter } from 'src/routes/hooks';
// config
import { PATH_AFTER_LOGIN } from 'src/config-global';

// auth
import { useAuthContext } from 'src/auth/hooks';
import { fetcher, endpoints } from 'src/utils/axios';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import httpCommon from 'src/http-common';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { IconButton, InputAdornment } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useBoolean } from 'src/hooks/use-boolean';
import axios from 'axios';
import useSWR from 'swr';
import Swal from 'sweetalert2';

// ----------------------------------------------------------------------

export default function JwtLoginView() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const id22 = queryParams.get('site_cd');
  const [body, setBody] = useState({});
  const [drpSata, setDrpData] = useState([]);
  const [drpFilter,setDrpFilter] =useState([])
  const [selectedValue, setSelectedValue] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState(drpSata);
 
  const { login } = useAuthContext();

  const router = useRouter();

  const [errorMsg, setErrorMsg] = useState('');
  const[name,setName] = useState("")
  const searchParams = useSearchParams();
  const password = useBoolean();

  const returnTo = searchParams.get('returnTo');
  // const navigate = useNavigate();
  const LoginSchema = Yup.object().shape({
    id: Yup.string().required('Staff ID is required'),
    password: Yup.string().required('password is required'),

    hospital: Yup.string().required('Hospital is required'),
  });

  useEffect(() => {
    fetchFilterDropdown();
  }, []);


  const fetchFilterDropdown = async () => {
    try {
      const response = await httpCommon.get('/get_sitecode.php');


      if (response.data.status === 'SUCCESS') {
      
        const data=response.data.data;
     
        const uniqueSiteCd = new Set();

    // Filter the data to ensure unique site_cd
    const filteredData = data.filter(item => {
        if (!uniqueSiteCd.has(item.site_cd)) {
            uniqueSiteCd.add(item.site_cd);
            return true; // Include this item in the filtered data
        }
        return false; // Exclude this item from the filtered data
    });

      setDrpFilter(filteredData)

        setDrpData(response.data.data);
   
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };



  // useEffect(() => {
  //   const selectedOption = drpSata.find((option) => option.site_cd === id22 && option.emp_mst_login_id == name  );
  //   console.log("selectedOption",selectedOption)
  //   if (selectedOption) {
  //     setSelectedValue(selectedOption);
  //   }
  // }, [id22, drpSata]);

  const defaultValues = {
    id: '',
    password: '',
    hospital: '',
  };
  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,

    formState: { isSubmitting },
  } = methods;



  const handleSubmit = async (e) => {
  
    e.preventDefault();
    const id = methods.getValues().id;
    const passwordParam = methods.getValues().password;
    const hospital = methods.getValues().hospital;
    const site = selectedValue?.site_cd;

    if (!id) {
      Swal.fire({
        title: `Login Id is required`,
        icon: 'error',
        showConfirmButton: false,
        allowOutsideClick: false,
        timer: 2000,
      });
    } else if (!passwordParam) {
      Swal.fire({
        title: `Password is required`,
        icon: 'error',
        showConfirmButton: false,
        allowOutsideClick: false,
        timer: 2000,
      });
    } else if (!site) {
      Swal.fire({
        title: `Site is required`,
        icon: 'error',
        showConfirmButton: false,
        allowOutsideClick: false,
        timer: 2000,
      });
    } else {
      try {
        // const response = await httpCommon.get('/authenticate_login.php', requestData);
        const response = await httpCommon.get(
          `/authenticate_login.php?login_id=${id}&password=${passwordParam}&site_cd=${site}`
        );
       console.log("LoginData",response)

        if (response.data.status === 'SUCCESS') {
          const LoginData =  response.data.data[0];
          // console.log("LoginData",LoginData[0])
          Swal.fire({
            title: `Login Success`,
            text: 'Welcome to Evantage CMMS',
            icon: 'success',
            showConfirmButton: false,
            allowOutsideClick: false,
            timer: 2000,
          });
          setTimeout(() => {
            // localStorage.setItem('QRId', id);
            // localStorage.setItem('Hsp', selectedValue.site_cd);
            // localStorage.setItem('HspName', selectedValue.site_name);
            // localStorage.setItem("emp_mst_empl_id",LoginData.emp_mst_empl_id)

            localStorage.setItem('ww_QRId', id);
            localStorage.setItem('ww_Hsp', selectedValue.site_cd);
            localStorage.setItem('ww_HspName', selectedValue.site_name);
            localStorage.setItem("ww_emp_mst_empl_id",LoginData.emp_mst_empl_id)

            navigate(PATH_AFTER_LOGIN, { replace: true });
          }, 2000);
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: `Invalid Login ID and Password`,
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };
  const [hospitalData, setHospitalData] = useState(null);

  // handle Id change
  const handleIdChange = async (event) => {
    const id = event.target.value;

    
const newId=id.toLowerCase()
setName(newId)
methods.setValue('id', newId);
    

    const userData = drpSata.find((item) => item.emp_mst_login_id && item.emp_mst_login_id.toLowerCase() === newId.toLowerCase());


    console.log("userData",userData)


    if (userData) {
      const hospitalName = userData;

      setSelectedValue(hospitalName);
    } else {
      setSelectedValue(null);
    }
  };

  // rendering head
  const renderHead = (
    <Stack spacing={2} sx={{ mb: 5 }} className="LoginImg">
      <Typography variant="h4">Sign in to CMMS Web Work</Typography>
    </Stack>
  );

  const renderForm = (
    <Stack spacing={2.5}>
      {!!errorMsg && <Alert severity="error">{errorMsg}</Alert>}
      <RHFTextField name="id" label="Login ID" onChange={handleIdChange} />
      <RHFTextField
        name="password"
        label="Password"
        type={password.value ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={password.onToggle} edge="end">
                <Iconify icon={password.value ? 'ri:eye-off-fill' : 'solar:eye-bold'} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Autocomplete
        name="hospital"
        value={selectedValue}
        onChange={(event, newValue) => {
          setSelectedValue(newValue);
          setErrorMsg('');
        }}
        // options={drpSata}
        options={drpFilter}
        getOptionLabel={(option) => `${option.site_cd} : ${option.site_name} `}
        getOptionValue={(option) => option.site_cd}
        renderInput={(params) => <TextField {...params} label="Site" variant="outlined" />}
      />
      {!!errorMsg && <Alert severity="error">{errorMsg}</Alert>}

      <LoadingButton
        fullWidth
        color="inherit"
        size="large"
        type="submit"
        variant="contained"
        loading={isSubmitting}
      >
        Login
      </LoadingButton>
    </Stack>
  );
  return (
    <>
      {/* <Toaster richColors /> */}
      <FormProvider methods={methods} onSubmit={handleSubmit}>
        {renderHead}

        {renderForm}
      </FormProvider>
    </>
  );
}
